<template>
  <div>
    <v-card flat tile style="width:100%;" class="d-flex justify-center">
      <v-layout :class="filterPosition" style="height:80px; width: 100%;">
        <div
          :class="buttonPosition"
          style="width:100%; height:80px; overflow:hidden;"
        >
          <v-btn
            v-if="showMobileView && (name === 'home' || name === 'devices')"
            class="ml-2 mr-2"
            tile
            width="100px"
            height="40px"
            id="filter-button"
            style="font-weight:bold; border: 2px solid black;"
            @click="openFilter()"
            ><v-icon>mdi-filter</v-icon>Filter</v-btn
          >
          <v-btn
            v-if="!showMobileView"
            class="mr-2 ml-4"
            tile
            color="gray"
            width="150px"
            outlined
            height="40px"
            id="filter-button"
            style="font-weight:bold;"
            @click="openFilter()"
            ><v-icon>mdi-filter</v-icon>Filter</v-btn
          >
          <v-btn
            class="d-flex justify-center align-center pa-3 ma-3"
            style="height:30px; width:fit-content;"
            text
            height="60"
            id="clear-button"
            :disabled="false"
            @click="clear()"
          >
            Clear All
          </v-btn>
          <div
            v-if="!showMobileView"
            class="d-flex flex-grow-1"
            style="overflow-y: hidden; min-width:65%;"
          >
            <div
              v-for="(item, index) in convertedFilter"
              :key="index"
              id="current-filter"
              class="d-flex justify-space-around align-center pa-3 ma-3"
              style="color:white; background-color:black; height:30px; min-width:fit-content; max-width:fit-content;"
            >
              <span
                style="height:30px; min-width:90%;"
                class="d-flex justify-space-around no-wrap align-center"
                >{{ item.value }}</span
              >
              <v-icon
                color="white"
                class="pl-2"
                @click="removeItem(item)"
                id="clear-current-filter-btn"
                >mdi-close</v-icon
              >
            </div>
            <v-card-text
              v-if="convertedFilter.length && !_dataPresent"
              class="red--text"
            >
              No results? Try other filter options
            </v-card-text>
          </div>
        </div>
        <search
          v-if="name !== 'home' && name !== 'reports' && !showMobileView"
          :searchTypes="searchTypes"
        />
      </v-layout>
    </v-card>
    <v-divider />
  </div>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';
import Search from './Search';
import { MobileView } from '@/mixins';
import FilterParams from '@/mixins/FilterParams';

export default {
  components: {
    Search,
  },
  mixins: [MobileView, FilterParams],
  props: ['filter', 'name', 'searchTypes'],
  data() {
    return {
      convertedFilter: [],
      renderComponent: true
    };
  },
  mounted() {
    if (this.$router.currentRoute.query.networkHealthFilter) {
      this.clear();
    }
  },
  methods: {
    ...mapMutations({
      _setFilter: 'filters/setFilter',
      _setFilters: 'filters/setFilters',
      _setFilterParams: 'filters/setFilterParams',
    }),
    ...mapActions({
      _getHomeData: 'home/getHomePageData',
      _getKeyData: 'digitalKeys/acquireData',
      _getGroupData: 'groups/acquireGroups',
      _getScreens: 'screens/getAllScreensData',
    }),
    convertFilter() {
      const filterArray = [];
      const newFilter = { ...this.filter };
      Object.keys(newFilter).map(key => {
        if (newFilter[key] === undefined || newFilter[key] === '') {
          delete newFilter[key];
        }
      });
      Object.keys(newFilter).map(key => {
        let value = null;
        if (
          key === 'group' ||
          key === 'groupName' ||
          key === 'group_name' ||
          key === 'searchGroups' ||
          key === 'group_id'
        ) {
          value = this._currentClient.groups.find(
            group => group.uuid === this.filter[key]
          );
          if (value && value.group_name) {
            value = value.group_name;
          }
        } else if (key === 'location') {
          value = this._currentClient.groups.find(
            group => group.uuid === this.filter[key]
          ).address.city;
        } else if (key === 'area') {
          const areaName = this._areas.find(
            area => area.value === this.filter[key]
          );
          value = areaName.text;
        } else if (key === 'codeUsed') {
          if (this.filter[key] === true) {
            value = 'Code Used';
          } else {
            value = 'Code Not Used';
          }
        } else {
          value = this.filter[key];
        }
        const filterObject = { value, name: key };
        if (
          key !== 'search' &&
          key !== 'searchType' &&
          key !== 'searchPage' &&
          key !== 'tokens' &&
          key !== 'page' &&
          this.filter[key] !== undefined &&
          this.filter[key] !== '' &&
          key !== 'name' &&
          key !== 'filter'
        ) {
          if (value) {
            filterObject.value = value.replace(/(^\w{1})|(\s{1}\w{1})/g, match => match.toUpperCase());
            if (newFilter.range && key !== 'start_date' && key !== 'end_date') {
              filterArray.push(filterObject);
            } else if (!newFilter.range && key !== 'range') {
              filterArray.push(filterObject);
            }
          }
        }
      });
      this.convertedFilter = filterArray;
    },
  },
  computed: {
    ...mapGetters({
      _currentClient: 'account/getCurrentClient',
      _filterOptions: 'filters/getHomeFilterOptions',
      _areas: 'areas/getAreas',
      _clientIsSet: 'account/getClientIsSet',
      _getClientGroupsAreSet: 'account/getClientGroupsAreSet',
      _dataPresent: 'filters/getDataPresent',
    }),
    filterParams: {
      get() {
        return this._filterParams;
      },
      set(val) {
        this._setFilterParams(val);
      },
    },
    filterPosition() {
      if (this.showMobileView) {
        return 'd-flex justify-center align-center';
      }
      return 'd-flex justify-space-between align-center';
    },
    buttonPosition() {
      if (this.showMobileView) {
        return 'd-flex align-center justify-space-around';
      }
      return 'd-flex align-center';
    },
  },
  watch: {
    _filterOptions: {
      handler() {
        if (this._getClientGroupsAreSet) {
          this.convertFilter();
        }
      },
      deep: true,
    },
    filter: {
      handler() {
        if (this._getClientGroupsAreSet) {
          this.convertFilter();
        }
      },
      deep: true,
    },
    _getClientGroupsAreSet() {
      this.convertFilter();
    },
  },
};
</script>

<style></style>
